var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-2 h-screen"},[_c('div',{staticClass:"h-screen w-full",attrs:{"id":"mapMain"}})])}]

export { render, staticRenderFns }